
import { postJson, get, post } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 获取用户绑定的书本信息
    async selectBindBookInfo(context, params) {
      const res = await post('/Study/recite-word-book/selectBindBookInfo', params)
      return res
    },
    // 获取用户词书列表
    async listBooks(context, params) {
      const res = await post('/Study/recite-word-book/listBooks', params)
      return res
    },
    // 用户绑定词书
    async bindOrRebindBook(context, params) {
      const res = await post('/Study/recite-word-book/bindOrRebindBook', params)
      return res
    },
    // 今日计划完成明细
    async todayPlanCompleteItem(context, params) {
      const res = await post('/Study/recite-word-daily-plan/todayPlanCompleteItem', params)
      return res
    },
    // 学习计划方案 滚轮
    async learnPlanRoller(context, params) {
      const res = await post('/Study/recite-word-plan/learnPlanRoller', params)
      return res
    },
    // 生成计划
    async makePlan(context, params) {
      const res = await post('/Study/recite-word-plan/makePlan', params)
      return res
    },
    // 调整计划
    async adjustmentPlan(context, params) {
      const res = await post('/Study/recite-word-plan/adjustmentPlan', params)
      return res
    },
    // 清除计划
    async clearPlan(context, params) {
      const res = await post('/Study/recite-word-plan/clearPlan', params)
      return res
    },
    // 学习计划列表
    async listDailyLearnPlan(context, params) {
      const res = await post('/Study/recite-word-daily-plan/listDailyLearnPlan', params)
      return res
    },
    // 今天需要学习的单词列表
    async listTodayLearnWords(context, params) {
      const res = await post('/Study/recite-word-daily-learn-record/listTodayLearnWords', params)
      return res
    },
    // 今天需要复习的单词列表
    async listTodayReviewWords(context, params) {
      const res = await post('/Study/recite-word-daily-review-record/listTodayReviewWords', params)
      return res
    }

  }
}
